import React from 'react';

const ClustersContext = React.createContext({});

export default ClustersContext;
